<script>
import {defineComponent} from 'vue'
import TicketLayouts from "@/components/Tickets/layouts/TicketLayouts.vue";
import ActionCard from "@/components/Tickets/ActionCard.vue";
import {mapActions, mapGetters} from 'vuex';

export default defineComponent({
  name: "TicketActions",
  components: {TicketLayouts, ActionCard},
  data() {
    return {
      // pagination
      currentPage: 1,
      perPage: 15,
      isTable: false,
      perPageOptions: [
        {value: 10, text: '10 на странице'},
        {value: 15, text: '15 на странице'},
        {value: 25, text: '25 на странице'},
        {value: 50, text: '50 на странице'}
      ],
      //
      actionParams: {
        title: "",
        name: "",
        parent_action_id: null,
        status_id: null,
        group_id: null,
        enabled: true,
        back_action_id: null
      },
      search: '',
      isOpenCreateActionModal: false,
      sidebarFields: [],
      isSidebarLoading: false,
      selectedAction: {},
      fields: [
        {key: 'id', label: '№', sortable: true},
        {key: 'date', label: 'Дата', sortable: true},
        {key: 'name', label: 'Название'},
        {key: 'enabled', label: 'Включено',},
        {key: 'username', label: 'Кем создан',},
        {key: 'title', label: 'Заголовок',},
        {key: 'status', label: 'Статус',},
        {key: "parent_action", label: "Родительское действие"},
        {key: "back_action", label: "Возвратное"},
        {key: "actions", label: "Действия"},
      ],
      treeConfig: {
        nodeWidth: 230,//+
        linkSeparation: 100, //+
        nodeHeight: 50, //+
        levelHeight: 370,
        buildMode: 'children',
        offsetRight: 400
      }
    }
  },
  computed: {
    rows() {
      const query = this.search.trim().toLowerCase()
      if (!query) return this.ticketActions || []
      return (this.ticketActions || []).filter(item =>
          [item.id, item.name, item.title].some(field => String(field ?? '').toLowerCase().includes(query)))
    },
    ...mapGetters('moduleTickets', ['ticketActions', 'groupOptions', 'statusOptions', 'parentActionOptions', 'isLoading', 'meta', 'links']),
    treeData() {
      return {
        children: this.buildTreeStructure()
      }
    }
  },
  methods: {
    ...mapActions('moduleTickets', ['getTicketGroups', 'getTicketStatuses', 'getTicketActions', 'createAction', 'updateAction', 'deleteAction']),
    buildTreeStructure() {
      if (!this.ticketActions || this.ticketActions.length === 0) {
        return []
      }

      // Создаем мапу всех действий по ID
      const actionsMap = new Map()
      const rawActions = []

      // Собираем все действия из пагинированных данных
      this.ticketActions.forEach(action => {
        const actionData = {
          ...action,
          _key: `action-${action.id}`,
          name: action.name,
          children: []
        }
        actionsMap.set(action.id, actionData)
        rawActions.push(action)
      })

      // Строим дерево на основе parent_action_id
      const roots = []
      rawActions.forEach(action => {
        const actionNode = actionsMap.get(action.id)

        // Если есть родитель, добавляем к нему как ребенка
        if (action.parent_action_id && actionsMap.has(action.parent_action_id)) {
          const parent = actionsMap.get(action.parent_action_id)
          parent.children.push(actionNode)
        } else {
          // Иначе это корневой элемент
          roots.push(actionNode)
        }
      })

      return roots
    },
    async createTicketAction() {
      try {
        await this.createAction(this.actionParams);
        this.$bvModal.hide('create-action');
        this.actionParams = {
          title: "",
          name: "",
          parent_action_id: null,
          status_id: null,
          group_id: null,
          enabled: true,
          back_action_id: null
        }
      } catch (e) {
        this.$bvToast.toast(e.message || 'Произошла ошибка', {
          title: e.message ? "Валидация" : "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    async openEditSidebar(item) {
      this.isSidebarLoading = true
      if (!this.groupOptions.length) {
        await this.getTicketGroups()
      }
      if (!this.statusOptions.length) {
        await this.getTicketStatuses()
      }
      this.isSidebarLoading = false
      this.sidebarFields = [
        {
          key: 'name',
          label: 'Название',
          type: 'text',
          placeholder: 'Введите название',
          required: true
        },
        {
          key: "title",
          label: "Заголовок",
          type: "text",
          placeholder: "Введите заголовок"
        },
        {
          key: 'group_id',
          label: 'Название группы',
          type: 'select',
          placeholder: 'Выберите название',
          options: this.groupOptions,
          required: true
        },
        {
          key: 'status_id',
          label: 'Статус',
          type: 'select',
          placeholder: 'Выберите статус',
          options: this.statusOptions,
          required: true
        },
        {
          key: 'parent_action_id',
          label: 'Выберите родительское действие',
          type: 'select',
          placeholder: 'Выберите действие',
          options: this.parentActionOptions,
          required: true
        },
        {
          key: 'back_action_id',
          label: 'Выберите возвратное действие',
          type: 'select',
          placeholder: 'Выберите действие',
          options: this.parentActionOptions,
        },
        {
          key: 'enabled',
          label: 'Включено',
          type: 'checkbox',
          default: true
        },
      ]
      this.selectedAction = {
        ...item,
        _original: item,
        enabled: item.enabled === "Да"
      }
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    async handleSaveAction(formData) {
      this.isSidebarLoading = true
      try {
        await this.updateAction({id: this.selectedAction.id, formData});
        this.$bvToast.toast('Действие успешно обновлено', {
          title: "Успех",
          variant: "success",
        })
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
        this.selectedCategory = null
      } catch (e) {
        this.$bvToast.toast(e.response?.message || e.response?.data?.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      } finally {
        this.isSidebarLoading = false;
      }
    },
    async handleDeleteAction(action) {
      try {
        await this.deleteAction(action.id);
      } catch (e) {
        this.$bvToast.toast(e.response?.message || e.response?.data?.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    onPageChange(page) {
      this.currentPage = page
      this.getTicketActions({page: page, per_page: this.perPage})
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    changePerPage() {
      this.currentPage = 1
      this.getTicketActions({page: 1, per_page: this.perPage})
    }
  },
  watch: {
    isOpenCreateActionModal: {
      handler(value) {
        if (value) {
          this.getTicketGroups()
          this.getTicketStatuses()
        }
      }
    },
    'meta.current_page': {
      handler(newPage) {
        if (newPage && this.currentPage !== newPage) {
          this.currentPage = newPage
        }
      }
    }
  },
  mounted() {
    this.getTicketActions({page: this.currentPage, per_page: this.perPage})
  },
})
</script>

<template>
  <TicketLayouts
      title="Редактировать действие"
      :sidebar-item="selectedAction"
      :sidebar-loading="isSidebarLoading"
      :sidebar-fields="sidebarFields"
      @sidebar-save="handleSaveAction"
  >
    <div class="tr">
      <Breadcrumbs main="Тикеты" title="Действия"/>

      <div class="container-fluid tr-wrap">
        <div class="tr-toolbar">
          <div class="tr-search">
            <i class="fa fa-search tr-search__icon"></i>
            <input type="search" class="tr-search__input" v-model="search"
                   placeholder="ID, название или заголовок…" @keydown.esc.prevent="search = ''"/>
            <button v-if="search" type="button" class="tr-search__clear" @click="search = ''">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <span class="tr-spacer"></span>

          <div class="tr-seg">
            <button type="button" class="tr-seg__btn" :class="{ 'is-on': !isTable }" @click="isTable = false">
              <i class="fa fa-sitemap"></i> Дерево
            </button>
            <button type="button" class="tr-seg__btn" :class="{ 'is-on': isTable }" @click="isTable = true">
              <i class="fa fa-list-ul"></i> Таблица
            </button>
          </div>

          <button type="button" class="tr-btn-primary" v-b-modal.create-action
                  @click="isOpenCreateActionModal = true">
            <i class="fa fa-plus"></i> Создать действие
          </button>
        </div>

        <div class="tr-panel">
          <!-- дерево -->
          <div v-if="!isTable" class="tree-wrapper">
            <div v-if="treeData && treeData.children && treeData.children.length" class="tree-container ml-3">
              <TreeView
                  :dataset="treeData"
                  linkStyle="straight"
                  direction="vertical"
                  :config="treeConfig"
                  :dragEnabled="false"
              >
                <template v-slot:node="{ node }">
                  <div class="action-node" @click="openEditSidebar(node)">
                    <div class="action-header">
                      <span class="action-id">№{{ node.id }}</span>
                      <span class="action-status" :class="node.enabled === 'Да' ? 'enabled' : 'disabled'">
                        {{ node.enabled }}
                      </span>
                    </div>
                    <div class="action-title">{{ node.name }}</div>
                    <div class="action-subtitle" v-if="node.title">{{ node.title }}</div>
                    <div class="action-info">
                      <div v-if="node.status" class="info-item">
                        <i class="fa fa-info-circle"></i> {{ node.status }}
                      </div>
                      <div v-if="node.username" class="info-item">
                        <i class="fa fa-user"></i> {{ node.username }}
                      </div>
                    </div>
                    <div class="action-buttons">
                      <button class="btn-edit" @click.stop="openEditSidebar(node)">Редактировать</button>
                      <button class="btn-delete" @click.stop="handleDeleteAction(node)">Удалить</button>
                    </div>
                  </div>
                </template>
              </TreeView>
            </div>
            <div v-else class="tr-empty">
              <div class="tr-empty__art"><i class="fa fa-sitemap"></i></div>
              <div class="tr-empty__title">Действий нет</div>
              <div class="tr-empty__text">Действия задают, как тикет переходит между статусами.</div>
              <button type="button" class="tr-btn-primary" v-b-modal.create-action
                      @click="isOpenCreateActionModal = true">
                <i class="fa fa-plus"></i> Создать действие
              </button>
            </div>
          </div>

          <!-- таблица -->
          <template v-else>
            <div v-if="!rows.length" class="tr-empty">
              <div class="tr-empty__art"><i class="fa fa-bolt"></i></div>
              <div class="tr-empty__title">{{ search ? 'Ничего не нашлось' : 'Действий нет' }}</div>
              <div class="tr-empty__text">
                {{ search ? 'Попробуйте изменить запрос.' : 'Действия задают, как тикет переходит между статусами.' }}
              </div>
            </div>

            <div v-else class="tr-table-wrap">
              <table class="tr-table">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Название</th>
                  <th>Заголовок</th>
                  <th>Статус</th>
                  <th>Родительское</th>
                  <th>Возвратное</th>
                  <th>Включено</th>
                  <th>Создано</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in rows" :key="'ac' + item.id">
                  <td><span class="tr-id">#{{ item.id }}</span></td>
                  <td><span class="tr-name">{{ item.name }}</span></td>
                  <td>{{ item.title }}</td>
                  <td><span class="tr-badge">{{ item.status }}</span></td>
                  <td class="tr-mono">{{ item.parent_action }}</td>
                  <td class="tr-mono">{{ item.back_action }}</td>
                  <td>
                    <span class="tr-badge" :class="item.enabled === 'Да' ? 'tr-badge--ok' : 'tr-badge--off'">
                      {{ item.enabled === 'Да' ? 'Включено' : 'Выключено' }}
                    </span>
                  </td>
                  <td class="tr-num">{{ item.date }}</td>
                  <td>
                    <div class="tr-actions">
                      <button type="button" class="tr-act" @click="openEditSidebar(item)"
                              v-b-tooltip.hover.top="'Редактировать'">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button type="button" class="tr-act tr-act--danger" @click="handleDeleteAction(item)"
                              v-b-tooltip.hover.top="'Удалить'">
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div v-if="rows.length" class="tr-foot">
              <div class="tr-foot__info">
                Показано с <b>{{ meta.from }}</b> по <b>{{ meta.to }}</b> из <b>{{ meta.total }}</b>
              </div>
              <div class="d-flex align-items-center">
                <b-form-select v-model="perPage" :options="perPageOptions" size="sm"
                               @change="changePerPage" class="mr-2" style="width: 90px"/>
                <b-pagination class="tr-pagination my-0" v-model="currentPage" :total-rows="meta.total"
                              :per-page="meta.per_page" :limit="7" @change="onPageChange" size="sm"/>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <b-modal id="create-action" hide-footer title="Новое действие">
      <div v-if="isLoading" class="d-flex justify-content-center h-100">
        <b-spinner></b-spinner>
      </div>
      <b-form @submit.prevent="createTicketAction" v-else>
        <label class="font-weight-bold">Название</label>
        <b-form-input v-model="actionParams.name" placeholder="Название"/>
        <label class="font-weight-bold mt-3">Заголовок</label>
        <b-form-input v-model="actionParams.title" placeholder="Заголовок"/>
        <b-form-group class="mt-3" label="Группа" label-for="group">
          <b-form-select id="group" v-model="actionParams.group_id" :options="groupOptions"/>
        </b-form-group>
        <b-form-group label="Статус" label-for="status">
          <b-form-select id="status" v-model="actionParams.status_id" :options="statusOptions"/>
        </b-form-group>
        <b-form-group label="Родительское действие" label-for="parent-action">
          <b-form-select id="parent-action" v-model="actionParams.parent_action_id" :options="parentActionOptions"/>
        </b-form-group>
        <b-form-group label="Возвратное действие" label-for="back-action">
          <b-form-select id="back-action" v-model="actionParams.back_action_id" :options="parentActionOptions"/>
        </b-form-group>
        <b-form-checkbox v-model="actionParams.enabled">Включено</b-form-checkbox>
        <b-button class="mt-3 w-100" variant="primary" type="submit">Создать</b-button>
      </b-form>
    </b-modal>
  </TicketLayouts>
</template>

<style scoped lang="scss">
@import "~@/assets/scss/ticket-ref.scss";

.tr-seg {
  display: inline-flex;
  padding: 3px;
  gap: 3px;
  background: var(--tr-soft);
  border: 1px solid var(--tr-border);
  border-radius: 10px;

  &__btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 30px;
    padding: 0 12px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: var(--tr-muted);
    font-size: 12.5px;
    font-weight: 500;
    cursor: pointer;

    &:hover { color: var(--tr-primary); }

    &.is-on {
      background: var(--tr-bg);
      color: var(--tr-primary);
      font-weight: 600;
    }
  }
}

.tree-wrapper {
  overflow-x: auto;
  width: 100%;
}

.tree-container {
  overflow: visible;
  max-height: calc(100vh - 200px);
  //width: 100%;
  //max-width: calc(100vw - 0px);
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  min-width: max-content;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;

    &:hover {
      background: #555;
    }
  }
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 16px;
  margin: 20px 0;
}

::v-deep .tree-view {
  min-height: 600px;
  width: max-content;
  min-width: max-content;
}

.action-node {
  background: white;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  max-width: 200px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(115, 102, 255, 0.3);
    transform: translateY(-2px);
  }

  .action-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;

    .action-id {
      font-size: 12px;
      font-weight: bold;
      color: #7366ff;
    }

    .action-status {
      font-size: 10px;
      padding: 3px 8px;
      border-radius: 12px;

      &.enabled {
        background: #28a745;
        color: white;
      }

      &.disabled {
        background: #6c757d;
        color: white;
      }
    }
  }

  .action-title {
    font-size: 14px;
    font-weight: 600;
    color: #2b2b2b;
    margin-bottom: 5px;
    word-wrap: break-word;
  }

  .action-subtitle {
    font-size: 11px;
    color: #808080;
    margin-bottom: 10px;
    word-wrap: break-word;
  }

  .action-info {
    margin-bottom: 10px;

    .info-item {
      font-size: 10px;
      color: #666;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      gap: 5px;

      i {
        color: #7366ff;
        width: 12px;
      }
    }
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 10px;

    button {
      width: 100%;
      padding: 6px 10px;
      border: none;
      border-radius: 6px;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s;

      &.btn-edit {
        background: #7366ff;
        color: white;

        &:hover {
          background: #5a4fd4;
        }
      }

      &.btn-delete {
        background: #dc3545;
        color: white;

        &:hover {
          background: #c82333;
        }
      }
    }
  }
}
</style>
